import ResourceAdmin from "./ResourceAdmin";

const FIELDS = [
  { name: "title", label: "Title", type: "text", list: true },
  { name: "body", label: "Body", type: "textarea", rows: 5 },
  { name: "priority", label: "Priority", type: "select", options: ["info", "warning", "urgent"], default: "info", list: true },
  { name: "is_active", label: "Active", type: "boolean", default: true, list: true },
];

export default function AnnouncementsAdmin() {
  return (
    <ResourceAdmin
      resource="announcements"
      title="Site-wide Announcements"
      subtitle={
        "Shown as a dismissible banner at the very top of every public page. " +
        "Use this for community-wide alerts (Eid timings, building closures, urgent news). " +
        "Need a slide inside the homepage prayer-times card instead? Use the “Prayer Card Banner” admin."
      }
      fields={FIELDS}
    />
  );
}
